import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Panel.module.css';

export interface PanelProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  /** `blueprint` is the planning-phase look: blue paper with white lines. */
  tone?: 'night' | 'blueprint' | 'lamp';
  as?: 'section' | 'div' | 'article' | 'aside';
  title?: ReactNode;
}

export function Panel({
  tone = 'night',
  as: Tag = 'section',
  title,
  className,
  children,
  ...rest
}: PanelProps) {
  return (
    <Tag
      className={[styles['panel'], styles[tone], className ?? ''].filter(Boolean).join(' ')}
      {...rest}
    >
      {title ? <h2 className={styles['title']}>{title}</h2> : null}
      {children}
    </Tag>
  );
}
